export const getMyLeadStatusLabel = (status) => {
  switch (status) {
    case 0:
      return "ثبت نام شده";
    case 1:
      return "تماس گرفته شده";
    default:
      return "-";
  }
};

export const getLeadStatusLabel = (lead_operators_lead) => {
  if (lead_operators_lead === null || lead_operators_lead === undefined || lead_operators_lead.length === 0) {
    return "ثبت نام شده";
  }

  switch (lead_operators_lead[0].status) {
    case 0:
      return "اختصاص یافت";
    case 1:
      return "تماس گرفته شده";
    default:
      return "ثبت نام شده";
  }
};
